import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

export interface EventDeleteConfirmDialogData {
  isSeriesEvent: boolean;
}

@Component({
  selector: 'app-event-delete-confirm-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatCheckboxModule,
  ],
  template: `
    <div class="event-delete-confirm-dialog">
      <h2 mat-dialog-title>
        <mat-icon color="warn" class="warning-icon">warning</mat-icon>
        Slet begivenhed?
      </h2>

      <mat-dialog-content>
        <p class="message">Slettede begivenheder kan ikke genskabes.</p>

        @if (data.isSeriesEvent) {
        <p class="series-warning">
          Dette event er del af en serie.
          <strong>Hele serien slettes permanent.</strong>
          Vil du kun slette denne dato, skal du først gøre eventet selvstændigt
          på side 1.
        </p>
        }

        <mat-checkbox [(ngModel)]="acknowledged" class="ack-checkbox">
          Jeg forstår, at denne handling ikke kan fortrydes
        </mat-checkbox>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Annuller</button>
        <button
          mat-raised-button
          color="warn"
          [disabled]="!acknowledged"
          (click)="onConfirm()"
        >
          Slet begivenhed
        </button>
      </mat-dialog-actions>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .warning-icon {
        margin-right: 8px;
        vertical-align: middle;
      }

      .message {
        font-size: 16px;
        margin-bottom: 12px;
        line-height: 1.5;
      }

      .series-warning {
        background-color: #fff3e0;
        border: 1px solid #ffb74d;
        border-radius: 4px;
        padding: 12px;
        margin: 0 0 16px;
        line-height: 1.5;
        font-size: 14px;
      }

      .ack-checkbox {
        display: block;
        margin-top: 8px;
      }

      mat-dialog-actions {
        padding: 16px 0 0 0;
        margin: 0;
      }

      mat-dialog-actions button {
        margin-left: 8px;
      }
    `,
  ],
})
export class EventDeleteConfirmDialogComponent {
  acknowledged = false;

  constructor(
    public dialogRef: MatDialogRef<EventDeleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EventDeleteConfirmDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
